import { EditorContent, useEditor } from "@tiptap/react";
import PropTypes from "prop-types";
import React from "react";

import styled from "styled-components/macro";

import CharacterCount from "@tiptap/extension-character-count";
import Link from "@tiptap/extension-link";
import StarterKit from "@tiptap/starter-kit";

import { colors } from "UI/colors";

import { EditorTypography } from "./EditorTypography";
import MenuBar from "./MenuBar";

FnrTextEditor.propTypes = {
  content: PropTypes.string.isRequired,
  setContent: PropTypes.func.isRequired,
  menuButtons: PropTypes.array,
  maxLength: PropTypes.number,
  maxHeight: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  minHeight: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  autofocus: PropTypes.string,
  disabled: PropTypes.bool,
  lineHeight: PropTypes.string,
  style: PropTypes.object,
};

export default function FnrTextEditor({
  content,
  setContent,
  menuButtons = ["bold", "italic", "ul", "ol", "link", "unlink"],
  maxLength,
  maxHeight,
  minHeight,
  autofocus = "end",
  disabled = false,
  lineHeight = "1.2rem",
  style,
}) {
  const editor = useEditor({
    content,
    onUpdate({ editor: localEditor }) {
      setContent(localEditor.getHTML());
    },
    autofocus,
    editable: !disabled,
    extensions: [
      StarterKit,
      Link.configure({
        openOnClick: false,
      }),
      CharacterCount.configure({
        limit: maxLength || null,
      }),
    ],
  });

  return (
    <Wrapper style={style}>
      {menuButtons?.length > 0 && (
        <MenuWrapper>
          <MenuBar
            menuButtons={menuButtons}
            editor={editor}
            disabled={disabled}
          />
        </MenuWrapper>
      )}
      <EditorWrapper
        maxHeight={maxHeight}
        minHeight={minHeight}
        lineHeight={lineHeight}
      >
        <EditorContent editor={editor} />
      </EditorWrapper>
    </Wrapper>
  );
}

const Wrapper = styled.div`
  position: relative;
  border-radius: 8px;
  border: 1px solid #ccc;
  padding: 4px;
  background: #fff;
  border: 1px solid ${colors.fnGray300};
  box-shadow: rgba(0, 0, 0, 0.1) 0 1px 4px;
`;

const MenuWrapper = styled.div`
  margin: -1px;
  margin-bottom: 5px;
`;

const EditorWrapper = styled(EditorTypography)`
  .ProseMirror {
    padding: 4px 3px;
    outline: none;
    border-radius: 10px;

    max-height: ${({ maxHeight }) => (maxHeight ? maxHeight : "none")};
    min-height: ${({ minHeight }) => (minHeight ? minHeight : "none")};
    overflow-y: auto;

    & p {
      margin: 0;
    }

    > * {
      line-height: ${(props) => props.lineHeight};
    }
  }
`;
